import { getRuntimeConfig } from '../../../app/config/runtime-config';

export type AccessRequestInput = {
  full_name: string;
  email: string;
  company: string;
  role_title?: string;
  machine_goal?: string;
  website?: string;
  source_path?: string;
};

export type AccessRequestResult = {
  request_id: string;
  status: 'RECEIVED';
  confirmation_email_status: 'SENT' | 'FAILED' | 'SKIPPED';
};

export async function submitAccessRequest(input: AccessRequestInput): Promise<AccessRequestResult> {
  const config = getRuntimeConfig();
  if (config.apiMode === 'mock') {
    await new Promise((resolve) => window.setTimeout(resolve, 120));
    return {
      request_id: `ar_local_${Date.now()}`,
      status: 'RECEIVED',
      confirmation_email_status: 'SENT',
    };
  }

  const response = await fetch(`${config.apiBaseUrl}/v1/public/access-requests`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });

  const text = await response.text();
  let body: unknown = null;
  if (text) {
    try {
      body = JSON.parse(text) as unknown;
    } catch {
      body = { message: text };
    }
  }
  if (!response.ok) {
    const record = body && typeof body === 'object' ? body as Record<string, unknown> : {};
    const nested = record.error && typeof record.error === 'object' ? record.error as Record<string, unknown> : {};
    throw new Error(String(nested.message ?? record.message ?? 'Route42 could not submit your request.'));
  }
  return body as AccessRequestResult;
}
